import React, { Component } from "react";
import { config } from "../../config/general.config";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectDisplayType extends Component {
  initState = {
    dataOption: config.enum_display_type,
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    try {
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label="Display Type" className="col-lg-12 my-1 py-1">
        <Select style={{ fontSize: "85%", minWidth: "200px" }} placeholder="Select Display Type" value={this.props.value} onChange={this.props.onChangeValue} mode={this.props.mode}>
          {this.state.dataOption.map((d, i) => {
            return (
              <Option key={d} value={d}>
                {d?.toString()?.toUpperCase()}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default SelectDisplayType;
